document.querySelectorAll('.shopify-section--ugc-content .ugc-slide__item').forEach(item => {
  const video = item.querySelector('.video-background video');
  const btn   = item.querySelector('.play-btn');
  const info  = item.querySelector('.ugc-content__info');
  if (!video || !btn || !info) return;

  btn.addEventListener('click', async () => {
    document.querySelectorAll('.shopify-section--ugc-content video').forEach(v => { if (v !== video) v.pause(); });
    video.muted = false;
    video.setAttribute('controls', 'controls');
    btn.classList.add('hidden');
    info.classList.add('hidden');      // 🔹 ocultamos el cuadro al empezar
    try { await video.play(); } catch(e) {}
  });

  // NO usamos 'pause' (evita parpadeos cuando haces seek)
  video.addEventListener('ended', () => {
    btn.classList.remove('hidden');
    info.classList.remove('hidden');   // 🔹 vuelve al terminar
    video.removeAttribute('controls');
  });
});
